import api from '@/api/axios';

export const getConsents = () => {
  return api
    .get(`/api/consent`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const postConsents = (document: unknown) => {
  return api
    .post(`/api/consent`, { consent: document })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
